import { render } from "./Step4Content.vue?vue&type=template&id=58895092&scoped=true"
const script = {}

import "./Step4Content.vue?vue&type=style&index=0&id=58895092&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58895092"]])

export default __exports__